import { render } from "./SportBar.vue?vue&type=template&id=8ebe3078&scoped=true"
import script from "./SportBar.vue?vue&type=script&lang=js"
export * from "./SportBar.vue?vue&type=script&lang=js"

import "./SportBar.vue?vue&type=style&index=0&id=8ebe3078&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ebe3078"]])

export default __exports__